import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService, IPagination } from "./api.service";

export interface Report {
  id: number;
  pan: string;
  confirmedName: string;
  transactionId: string;
  creditsUsed: number;
  isSuccessful: boolean;
  createdAt: string;
}

export interface ReportsPagination {
  total: number;
  totalPages: number;
  currentPage: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface ReportsResponse {
  success: boolean;
  data: {
    reports: Report[];
  };
  message: string;
  pagination: ReportsPagination;
}

@Injectable({
  providedIn: "root",
})
export class ReportsService {
  constructor(private apiService: ApiService) {}

  getPreviousReports(params: IPagination): Observable<ReportsResponse> {
    return this.apiService.get<ReportsResponse>("previous-reports", {
      params: {
        page: params.page || 1,
        limit: params.limit || 10,
        sortBy: params.sortBy || "createdAt",
        sortOrder: params.sortOrder || "desc",
      },
    });
  }
}
